// extracted by mini-css-extract-plugin
export default {"configuration":"Configuration_configuration__NW5A1","configurationHeader":"Configuration_configurationHeader__0LGGb"};